import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--image-loading-animation"
export default class extends Controller {
  static targets = ["loading", "hidden", "eventSource"];
  connect() {}

  loading(e) {
    this.hiddenTarget.classList.add("hidden");
    this.loadingTarget.classList.remove("hidden");

    setTimeout(() => {
      const event = new CustomEvent("imageLoadingAnimation:after", {
        detail: { e: e },
        bubbles: true,
        composed: true,
      });
      this.eventSourceTarget.dispatchEvent(event);
    }, 300);
  }

  unloading(e) {
    this.loadingTarget.classList.add("hidden");
    this.hiddenTarget.classList.remove("hidden");
  }
}
